import { Module } from "vuex";
import { IPowerBiState, initialState } from "./state";
import { getters } from "./getters";
import { mutations } from "./mutations";
import { actions } from "./actions";

const powerbi: Module<IPowerBiState, any> = {
    namespaced: true,
    state: initialState,
    getters,
    mutations,
    actions,
};

export { powerbi };
